import { FC, useEffect, useState } from 'react'
import { SelectChangeEvent, Typography } from '@mui/material'
import SelectV2 from 'ui/components/form-components-v2/select-v2'
import { JiraProject } from 'models'
import { ProductsServiceV4 } from 'services/v4/products-v4.service'
import { StepFieldWrapper } from '../../jiraWizard.styles'

interface Props {
  productId?: string
  value: string
  disabled?: boolean
  onChange: (projectKey: string) => void
}

/* Project Selection step: the customer's real Jira projects in a searchable
 * single select. The step submits one project key. */
const ProjectSelectionStep: FC<Props> = ({ productId, value, disabled, onChange }) => {
  const [projects, setProjects] = useState<JiraProject[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!productId) return

    let active = true
    setLoading(true)
    ProductsServiceV4.getJiraProjects(productId)
      .then((res) => {
        if (active) setProjects(res || [])
      })
      .catch((e) => console.error(e))
      .finally(() => {
        if (active) setLoading(false)
      })

    return () => {
      active = false
    }
  }, [productId])

  return (
    <StepFieldWrapper>
      <Typography className="field-label">Project</Typography>
      <SelectV2
        id="connected_projects"
        label=""
        searchable
        placeholder="Select Project"
        value={value}
        options={projects.map((project) => ({ label: project.name, value: project.key }))}
        disabled={disabled || loading}
        onChange={(e: SelectChangeEvent<unknown>) => onChange(e.target.value as string)}
      />
    </StepFieldWrapper>
  )
}

export default ProjectSelectionStep
